import { Box, CircularProgress, Container, Grid } from "@mui/material";
import OutlinedButton from "../OutlinedButton";
import SectionHeader from "../SectionHeader";
import Event from "../Event";
import moment from "moment";
import { useEvents } from "../../hooks/useEvents";
import styles from "./styles";


const Events = () => {
  const { data: allEvents, isLoading, loadMore, hasMore } = useEvents();

  return (
    <Container maxWidth="lg"><Grid container>
      <SectionHeader
        title={"Events"}
        description={"Below you can find our Events"}
      />
      <Box sx={styles.gridSx}>
        {allEvents.map(({ imageURL, _id, name, date }) => (
          <Event
            key={_id}
            image={imageURL}
            title={name}
            date={moment(date).format("MMMM Do, YYYY")}
            id={_id}
          />
        ))}
      </Box>
      {hasMore && (
        <Box sx={styles.buttonWrapperSx}>
          <OutlinedButton
            onClick={loadMore}
            disabled={isLoading}
            sx={styles.buttonSx}
          >
            {isLoading ? <CircularProgress size={20} sx={styles.progressSx} /> : "LOAD MORE"}
          </OutlinedButton>
        </Box>
      )}
    </Grid></Container>
  );
};

export default Events;
